import {
  Box,
  Container,
  Grid,
  Typography,
} from '@mui/material'
import { RichTextEditor } from 'components'
import { observer } from 'mobx-react'
import { Course, Step } from 'models'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { GridCard } from './gridCard'
import { handleAttachments } from './util'

export interface IGridEditorProps {
  course?: Course
  passed?: boolean
}

export const GridEditor = observer((props: IGridEditorProps) => {
  const { course } = props;
  const { t }      = useTranslation();

  const step: Step = course?.getCurStep;

  if (!step) return null;

  return (
    <>
      <Box
      className      = 'gridEditor'
      display        = 'flex'
      flexDirection  = 'column'
      justifyContent = 'center'
      pt             = {3}
      >
        <Grid container>
          <Grid xs={12} mb={3} item >
            <Typography textAlign='center' variant='h4'>
              {course.curStep.title}
            </Typography>
          </Grid>
          <Grid xs={12} mb={3} item>
            <div style={{margin: "auto", display: "flex", justifyContent: "center"}}>
              <RichTextEditor
                autoFocus    = {false}
                value        = {step.getBlocks[0]}
                defaultValue = {step.getBlocks[0]}
                onChange     = {(content: string) =>
                  step.updateBlock(0, content)
                }
                onImageUploadBefore={(files, info, uploadHandler) =>
                  handleAttachments(course, files, info, uploadHandler)
                }
              />
            </div>
          </Grid>
        </Grid>
      </Box>
      <Container maxWidth='md'>
        <Grid container spacing={2}>
          {step.getGridSteps.map((s, idx) => (
            <Grid item xs={6} key={s.id}>
              <GridCard course={course} step={s} idx={idx} edit={true} />
            </Grid>
          ))}
          {step.getGridSteps.length < 10 &&
            step.getGridSteps.length % 2 
            ? (
              <Grid item xs={6} key={"placeholder"}>
                <GridCard course={course} edit={true} />
              </Grid>
            )
            : step.getGridSteps.length < 10 && (
              <>
                <Grid item xs={3} key="stud_-1"></Grid>
                <Grid item xs={6} key={"placeholder"}>
                  <GridCard course={course} edit={true} />
                </Grid>
                <Grid item xs={3} key="stud_2.5"></Grid>
              </>
            )
          }
        </Grid>
      </Container>
    </>
  )
});